import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import useCioBrowseFacets from '../../hooks/useCioBrowseFacets';
import useSelectedFacetsToApply from '../../hooks/useSelectedFacetsToApply';
import { sanitizeFilterName } from '../../utils/filters';
import CheckboxInput from '../SharedGridFiltersUi/CheckboxInput';

const FilterFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: none;
`;

const HiddenLegend = styled.legend`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;

const MobileGridDefaultFilter = ({ options, name }) => {
  const { selectedUrlFilters } = useCioBrowseFacets();
  const sanitizedName = sanitizeFilterName(name);

  const { toggleSelectedFacetsToApply, isFacetOptionSelected } =
    useSelectedFacetsToApply();

  const handleOnChange = ({ facetName, facetOption }) => {
    toggleSelectedFacetsToApply({
      facetName,
      facetOption,
    });
  };

  return (
    <FilterFieldset>
      <HiddenLegend>{name}</HiddenLegend>
      {options?.map((option) => {
        const inputId = `${name}-${option.value}`;
        const isSelected = isFacetOptionSelected({
          facetName: name,
          facetOption: option.value,
          selectedUrlFilters,
        });

        return (
          <CheckboxInput
            key={option.value}
            id={inputId}
            name={option.value}
            label={option.display_name}
            checked={isSelected}
            onChange={() =>
              handleOnChange({
                facetName: name,
                facetOption: option.value,
              })
            }
            filterName={sanitizedName}
          />
        );
      })}
    </FilterFieldset>
  );
};

MobileGridDefaultFilter.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      display_name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MobileGridDefaultFilter;
